// BAITable.js
import React from "react";
function BAITable({ gender }) {
  return (
    <div style={{ overflowX: "auto" }}>
      {gender === "female" && (
        <>
          <h3>Tabel Indeks Obesitas untuk Wanita</h3>
          <table >
            <thead>
              <tr>
                <th >Usia (tahun)</th>
                <th >Kekurangan Berat Badan</th>
                <th >Sehat</th>
                <th >Kelebihan Berat Badan</th>
                <th >Obesitas</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>20 - 39</td>
                <td>Kurang dari 21%</td>
                <td>21% hingga 33%</td>
                <td>Lebih dari 33%</td>
                <td>Lebih dari 39%</td>
              </tr>
              <tr>
                <td>40 - 59</td>
                <td>Kurang dari 23%</td>
                <td>23% hingga 35%</td>
                <td>Lebih dari 35%</td>
                <td>Lebih dari 41%</td>
              </tr>
              <tr>
                <td>60 - 79</td>
                <td>Kurang dari 25%</td>
                <td>25% hingga 38%</td>
                <td>Lebih dari 38%</td>
                <td>Lebih dari 43%</td>
              </tr>
              <tr>
                <td colSpan="5">
                  <b>Sumber:</b>{" "}
                  <a href="https://pubmed.ncbi.nlm.nih.gov/22484365/">
                    Organisasi Kesehatan Dunia
                  </a>
                 </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      {gender === "male" && (
        <>
          <h3>Tabel Indeks Obesitas untuk Pria</h3>
          <table >
            <thead>
              <tr>
                <th >Usia (tahun)</th>
                <th >Kekurangan Berat Badan</th>
                <th >Sehat</th>
                <th >Kelebihan Berat Badan</th>
                <th >Obesitas</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>20 - 39</td>
                <td>Kurang dari 8%</td>
                <td>8% hingga 21%</td>
                <td>Lebih dari 21%</td>
                <td>Lebih dari 26%</td>
              </tr>
              <tr>
                <td>40 - 59</td>
                <td>Kurang dari 11%</td>
                <td>11% hingga 23%</td>
                <td>Lebih dari 23%</td>
                <td>Lebih dari 29%</td>
              </tr>
              <tr>
                <td>60 - 79</td>
                <td>Kurang dari 13%</td>
                <td>13% hingga 25%</td>
                <td>Lebih dari 25%</td>
                <td>Lebih dari 31%</td>
              </tr>
              <tr>
                <td colSpan="5">
                  <b>Sumber:</b>{" "}
                  <a href="https://pubmed.ncbi.nlm.nih.gov/22484365/">
                    Organisasi Kesehatan Dunia
                  </a>
                 </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
export default BAITable;